import React from 'react';

const GarageIcon = (props) => (
  <svg
    width="18"
    height="19"
    viewBox="0 0 18 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1 18.3333V12.3333H17V18.3333H15V14.3333H3V18.3333H1ZM1.5 11.3333C1.08333 11.3333 0.729167 11.1875 0.4375 10.8958C0.145833 10.6041 0 10.25 0 9.83331C0 9.41665 0.145833 9.06248 0.4375 8.77081C0.729167 8.47915 1.08333 8.33331 1.5 8.33331C1.91667 8.33331 2.27083 8.47915 2.5625 8.77081C2.85417 9.06248 3 9.41665 3 9.83331C3 10.25 2.85417 10.6041 2.5625 10.8958C2.27083 11.1875 1.91667 11.3333 1.5 11.3333ZM4 11.3333V2.33331C4 1.78331 4.19583 1.31248 4.5875 0.920813C4.97917 0.529146 5.45 0.333313 6 0.333313H12C12.55 0.333313 13.0208 0.529146 13.4125 0.920813C13.8042 1.31248 14 1.78331 14 2.33331V11.3333H4ZM16.5 11.3333C16.0833 11.3333 15.7292 11.1875 15.4375 10.8958C15.1458 10.6041 15 10.25 15 9.83331C15 9.41665 15.1458 9.06248 15.4375 8.77081C15.7292 8.47915 16.0833 8.33331 16.5 8.33331C16.9167 8.33331 17.2708 8.47915 17.5625 8.77081C17.8542 9.06248 18 9.41665 18 9.83331C18 10.25 17.8542 10.6041 17.5625 10.8958C17.2708 11.1875 16.9167 11.3333 16.5 11.3333Z"
      fill="#0087FF"
    />
  </svg>
);

export default GarageIcon;
